import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

const MobileSectionsButton: React.FC<{isMobile: boolean, toggle: () => void}> =
({ isMobile, toggle }) => {
  if (isMobile) {
    return (
      <Grid item xs={12}>
        <Button size="small" onClick={toggle}>← Sections</Button>
      </Grid>
    );
  }
  return null;
};

export default MobileSectionsButton;
